import React, { useState, useEffect, useMemo } from "react";

const About = () => {
  return <div>about page</div>;
};

export default About;
